// extracted by mini-css-extract-plugin
export default {"tableContainer":"summaryTable_tableContainer__F2Fjg","complianceRangeContainer":"summaryTable_complianceRangeContainer__QeuVx","scoreDeduction":"summaryTable_scoreDeduction__eyweQ"};